import * as React from 'react';
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '100%', mr: 1 }}>
                <LinearProgress variant="determinate" {...props} />
            </Box>
            <Box sx={{ minWidth: 35 }}>
                <Typography variant="body2" color="text.secondary">{`${Math.round(
                    props.value,
                )}%`}</Typography>
            </Box>
        </Box>
    );
}

interface props {
    num: number;
    color?: string;
}


const RangeCustom = (props: props) => {
    return (
        <Box sx={{ width: '100%' }}>
            <LinearProgressWithLabel
                sx={{
                    backgroundColor:"#f4f0ee",
                    '& .MuiLinearProgress-bar': {
                        backgroundColor: props.color ? props.color : "#1976d2",
                    },
                }}
                value={props.num} />
        </Box>
    );
}

export default RangeCustom